import {
  Component,  
  OnInit
} from '@angular/core';

import{Router, NavigationEnd} from '@angular/router';
import { filter } from 'rxjs/operators';

declare var gtag;

@Component({
  selector: 'app-arc-shared-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {

  constructor(router: Router) { 
    const navEndEvent$ = router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    );
    navEndEvent$.subscribe((event: NavigationEnd) => {
      gtag('config', 'G-J0M0RFM1YT', {'page_path':event.urlAfterRedirects});
    });
   }
  ngOnInit() {  }
}
